import _ from "lodash";
import { PropsWithChildren } from "react";
import styles from "./ProcessProgress.module.css";

interface ProcessProgressProps {
    currentStep: number;
    totalSteps: number;
}

export const ProcessProgress = (props: PropsWithChildren<ProcessProgressProps>) => {
    const w = 30 * (props.totalSteps) + 25;
    const h = 55;
    return (
        <div className={styles.ProcessProgressContainer}>
            <h2 className={styles.ProcessProgressTitle}>{props.children}</h2>
            <div>
                {props.totalSteps > 1 && (
                    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
                        <defs>
                            <clipPath id="clipPath">
                                {_.range(1, props.totalSteps + 1).map((i) => (
                                    <path
                                        key={i}
                                        transform={`translate(${(i - 1) * 30} 0)`}
                                        d="M29,13.5H14.3c-1.5,0-2.8,1.2-2.8,2.8v0c0,0.7,0.3,1.4,0.8,2l9.3,9.3l-9.3,9.3
                                        c-0.5,0.5-0.8,1.2-0.8,2v0c0,1.5,1.2,2.8,2.8,2.8H29c1.2,0,2.3-0.5,3.1-1.3l10.6-10.8c1.1-1.1,1.1-2.8,0-3.9L32.1,14.8
                                        C31.3,14,30.2,13.5,29,13.5z"
                                    />
                                ))}
                            </clipPath>
                        </defs>

                        <svg x={0} y={0} style={{ clipPath: "url(#clipPath)" }}>
                            <polygon
                                transform={`translate(${(props.currentStep - 1) * 30} 0)`}
                                points="33.3,11.4 6.4,11.4 6.4,15.9 18.1,27.5 6.4,39.1 6.4,43.6 33.3,43.6 49.2,27.5 "
                                style={{ fill: "var(--primary)", opacity: 1, transition: "all 260ms ease-in-out" }}
                            />
                        </svg>

                        <rect
                            x="0"
                            y="0"
                            width={w}
                            height={h}
                            style={{ fill: "var(--primary)", opacity: 0.33, clipPath: "url(#clipPath)" }}
                        />

                        {_.range(1, props.totalSteps + 1).map((i) => (
                            <text key={i} x={(i - 1) * 30 + 24} y="34" className={styles.ProcessProgressStepNumber}>
                                {i}
                            </text>
                        ))}
                    </svg>
                )}
            </div>
        </div>
    );
};
